export const FORMAT_DATE_DAYJS = 'DD/MM/YYYY';
export const FORMAT_DATE_WITH_TIME_DAYJS = 'DD/MM/YYYY h:mm A';
export const FORMAT_FULL_TIME_DAYJS = 'DD/MM/YYYY, HH:mm:ss';
export const FORMAT_DATE_HH_MM = 'h:mm a';
export const MAX_FILE_SIZE = 1e7; // up to 10MB
export const acceptFiles = 'image/*, .jpg, .png, .pdf, .xlsx, .xls, .csv';
export const acceptImageFiles = 'image/*, .jpg, .jpeg, .png, .webp';

export const allowedFileExtensions = (files: string) =>
  files.split(/[, ]+/).filter(Boolean);

export const checkIsImage = (url: string) => {
  const imageRegex = /\.(png|jpe?g|gif|webp|bmp)(\?.*)?(#.*)?$/i;
  return imageRegex.test(url);
};

// https://developer.mozilla.org/en-US/docs/Web/Media/Formats/Image_types#common_image_file_types
export const ImageSupportedExtensions = [
  'apng',
  'avif',
  'gif',
  'jpg',
  'jpeg',
  'pjpeg',
  'pjp',
  'png',
  'svg',
  'webp',
  'bmp',
  'ico',
  'cur',
  'tif',
  'tiff',
];

// XLSX library supported formats: https://docs.sheetjs.com/docs/miscellany/formats
export const XLSXSupportedExtensions = [
  'xls',
  'xlsx',
  'xlsm',
  'xlsb',
  'csv',
  'txt',
  'dif',
  'sylk',
  'slk',
  'prn',
  'et',
  'ods',
  'fods',
  'uos1',
  'uos2',
  'dbf',
  'wks',
  'wk1',
  'wk2',
  'wk3',
  'wk4',
  'wq1',
  'wq2',
  'wb1',
  'wb2',
  'wb3',
  'qpw',
  'xlr',
  'eth',
];

export enum CarDamageAreaCode {
  Front = 'V', // FRONT
  RightSide = 'R', // RIGHT-HAND SIDE
  Rear = 'H', // REAR
  LeftSide = 'L', // LEFT-HAND SIDE
  Top = 'D', // ROOF
  Outside = 'A', // ENTIRE
  Underbody = 'U', // UNDERBODY
  Interior = 'I', // INTERIOR

  Mechanical = 'M',
}

export enum CarAreaCode {
  OD01 = 'OD01',
  OD02 = 'OD02',
  OD03 = 'OD03',
  OD04 = 'OD04',
  OD05 = 'OD05',
  OD06 = 'OD06',
  OD07 = 'OD07',
  OD08 = 'OD08',
  OD09 = 'OD09',
  OD10 = 'OD10',
  OD11 = 'OD11',
  OD12 = 'OD12',
  OD13 = 'OD13',

  ID01 = 'ID01',
  ID02 = 'ID02',
}

export enum StorageKeys {
  SearchInspections = 'searchInspections',
  SearchJobs = 'searchJobs',
  SearchCompoundJobs = 'searchCompoundJobs',
  CompoundJobsView = 'compoundJobsView',
  SearchDamageExceptions = 'searchDamageExceptions',
  SearchStorageVehicles = 'searchStorageVehicles',
  SearchQuestionnaireResponses = 'searchQuestionnaireResponses',
}

export enum ReplaceImageType {
  Odometer = 0,
  WheelsAndTyresFrontLeft = 1,
  WheelsAndTyresFrontRight = 2,
  WheelsAndTyresRearLeft = 3,
  WheelsAndTyresRearRight = 4,
  WheelsAndTyresSpare = 5,
  ImagesFront = 6,
  ImagesRear = 7,
  ImagesNearside = 8,
  ImagesOffside = 9,
  ImagesChargeLevel = 10,
  DamageImage = 11,
  ImagesChargeCables = 12,
  ImagesKeys = 13,
  ImagesIstaCheckList = 14,
}

export enum LocalStorageKeys {
  CustomerIds = 'customerIds',
  LocationIds = 'locationIds',
  LoadLaneCustomerId = 'loadLaneCustomerId',
  LoadLaneSiteId = 'loadLaneSiteId',
  PendingInspectionsExport = 'pendingInspectionsExport',
}
